import Axios from 'axios';

import { API_URL } from './variables';

export default Axios.create({
  baseURL: API_URL,
});
